<div class="card">
    <div class="heading">

        <span class="pi pi-user"></span>&nbsp;
        <h3 id="h3"> Details of Selected Doctor </h3>

    </div>

    <p-table *ngIf="doctor !=null">
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align:left; width: 300px;"><b>Name</b></th>
                <th style="text-align:left;">{{doctor.first_name+" "+doctor.middle_name+" "+doctor.last_name}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Date of Birth</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">{{doctor.date_of_birth}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>Gender</b></th>
                <th style="text-align:left;">{{doctor.gender}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Email</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">{{doctor.d_email}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>Primary Contact Number</b></th>
                <th style="text-align:left;">{{doctor.primary_contact_number}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>Country</b></th>
                <th style="text-align:left;">{{doctor.country.country_name}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>State</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">{{doctor.state_name}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>City</b></th>
                <th style="text-align:left;">{{doctor.city}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Zip Code</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">{{doctor.zip_code}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>Address 1</b></th>
                <th style="text-align:left;">{{doctor.address_line_1}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Address 2</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">{{doctor.address_line_2}}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>Date of Joining</b></th>
                <th style="text-align:left;">{{ doctor?.joined_date?.substring(0,10) }}</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Account Status</b></th>
                <th style="text-align:left;background-color:#AEC5E3;" *ngIf="doctor.is_active">Active</th>
                <th style="text-align:left;background-color:#AEC5E3;" *ngIf="!doctor.is_active">Inactive</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;"><b>EGD Role</b></th>
                <th style="text-align:left;" *ngIf="doctor.role_id==1">Doctor</th>
                <th style="text-align:left;" *ngIf="doctor.role_id==2">Admin</th>
                <th style="text-align:left;" *ngIf="doctor.role_id==3">Super Admin</th>
                <th style="text-align:left;" *ngIf="doctor.role_id==4">Super Admin Doctor</th>
                <th style="text-align:left;" *ngIf="doctor.role_id==5">Admin Doctor</th>
                <th style="text-align:left;" *ngIf="doctor.role_id==6">Other Health Care Provider</th>
            </tr>
            <tr>
                <th style="text-align:left; width: 300px;background-color:#AEC5E3;"><b>Date of Termination</b></th>
                <th style="text-align:left;background-color:#AEC5E3;">
                    {{ doctor?.terminated_date?.substring(0,10) }}</th>
            </tr>
            <!-- <tr>
                <th style="text-align:left; width: 300px;">
                    <p-button icon="pi pi-chevron-circle-left" (click)="prev()"></p-button>
                </th>
                <th>
                </th>
            </tr> -->
        </ng-template>



    </p-table>

</div>
